import React from 'react'
import { SVGIcon } from '~/utils/types'


export const Plus = (props: SVGIcon) => (
  <svg
    {...props}
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 16 16"
  >
    <path
      fillRule="evenodd"
      d="M8 1.5c.414 0 .75.336.75.75v4.999l5 .001c.414 0 .75.336.75.75s-.336.75-.75.75l-5-.001v5.001c0 .414-.336.75-.75.75s-.75-.336-.75-.75V8.749l-5 .001c-.414 0-.75-.336-.75-.75s.336-.75.75-.75l5-.001V2.25c0-.414.336-.75.75-.75z"
    />
  </svg>
)
